export const GetBranchPrefix = () => {
  // @ts-expect-error TODO: This is set by webpack globally
  const branchPrefix = __GIT__BRANCH__
  if (branchPrefix && branchPrefix !== "master" && branchPrefix !== "develop") {
    return "/" + branchPrefix;
  } else {
    return "";
  }
}

export const GetBaseHref = () => {
  return window.location.origin + GetBranchPrefix();
}

export const GetPath = (pagePath: string) => {
  return GetBaseHref() + pagePath;
}
